import React, { useState, useEffect, useRef } from 'react';
import { getCropList } from '../util/APIUtils';
import {
    Select,
} from 'antd';

function CropSelect({setItem, setFormattedItems,  selectedItem, placeholder }) {

    let useMyData = getCropList();

    const { isLoading, error, data, refetch } = useMyData(
        (jsonData) => jsonData,
    );

    const handleChange = selectedItem => {
        setItem(selectedItem);
    };

    return (
        <>
       
            <Select
                showSearch
                mode="single"
                loading={isLoading}
                onChange={handleChange}
                placeholder={placeholder || "Gegenstände auswählen"}
                defaultValue={selectedItem}
                // onChange={handleChange}
                optionFilterProp="children"
                style={{ width: '250px' }}
            >
                 {!isLoading &&
                data.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                        {item.name}
                    </Select.Option>
                ))
}
            </Select> 

        </>
    )
}

export default CropSelect